import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  customerAdminFetchContactsSuccess,
  customerAdminShowContactMessage,
  submitNewCustomerAdminResponse,
  submitEditCustomerDetailsResponse,
  selectedCustomerDeleteResposne,
  toggleCustomerModal,
  customerFailResponse,
  setCustomerList,
  changeAdminLoader,
  adminBookFailResponse,
  updateCustomerList,
  callCustomerApi
} from "../actions";
import {
  CUSTOMER_ADMIN_FETCH_ALL_CONTACT,
  SUBMIT_NEW_CUSTOMER_ADMIN,
  SELECTED_CUSTOMER_DELETE,
} from "../constants/ActionTypes";
import axios from "../services/admin";
import admin from "../services/admin";
import { formatPhone } from "../util/normalizePhone";

function* fetchCustomerRequest(action) {
  try {
    const user = JSON.parse(localStorage.getItem("user-data"));
    let fetchedContact;
    if (user) {
      if (user.role.name == "Business Owner") {
        fetchedContact = yield axios.get(
          `/customers?location=${user.business.business_locations[0]._id}`
        );
      } else {
        fetchedContact = yield axios.get("/customers");
      }
    }
    const Data = fetchedContact.data.filter(item => item != null) 
    Data.forEach(element => {
      element.primary_details.phonenumber = formatPhone(element.primary_details.phonenumber);
    });
    // for(let i = 0; i< Data.length; i++) {
    //   Data[0]
    // }
    yield put(customerAdminFetchContactsSuccess(Data));
  } catch (error) {
    yield put(customerFailResponse(error.response.data.message));
  }
}

function* submitNewCustomer({ payload }) {
  try {
    const { addCustomerState, editCustomerState } = payload;
    if (addCustomerState) {
      const { formValues, imageFile } = payload;
      const { firstname, lastname, phonenumber, email } = formValues;

      const userRequest = {
        firstname,
        lastname,
        phonenumber: `+${phonenumber.replace(/[^\d]/g, "")}`,
        email,
        username: email,
        role: "5bce0f4b7e768500167699c6",
      };

      const userResponse = yield axios.post("/users", userRequest);

      const { address1, address2, city, stateId: state, zipcode, gender, country } = formValues;

      const { date_of_birth } = payload;
      const customerRequest = {
        date_of_birth,
        address1,
        address2,
        city,
        state,
        zipcode,
        gender,
        country,
        primary_details: userResponse.data._id,
      };
      const user = JSON.parse(localStorage.getItem('user-data'));
      if(user.role.name == 'Business Owner'){
        customerRequest.location = user.business.business_locations[0]._id;
      }
      const customerResponse = yield axios.post("/customers", customerRequest);
      const myCustomer = { ...customerResponse.data };
      console.log("PAYLOD>IMAGEID",payload.imageid);
      
      if (imageFile) {
  
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", customerResponse.data._id);
        file.append("ref", "customers");
        file.append("field", "photo");

        const fileResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        myCustomer.photo = fileResponse.data[0];
      }
      myCustomer.primary_details.phonenumber = formatPhone(myCustomer.primary_details.phonenumber);
      yield put(toggleCustomerModal(false));
      yield put(updateCustomerList(myCustomer));
      yield put(callCustomerApi());
      yield put(submitNewCustomerAdminResponse(myCustomer));
    } else if (editCustomerState) {
      const { formValues, imageFile } = payload;
      const { firstname, lastname, phonenumber, email, checkEmail } = formValues;

      const userRequest = {
        firstname,
        lastname,
        phonenumber: `+${phonenumber.replace(/[^\d]/g, "")}`,
        role: "5bce0f4b7e768500167699c6",
      };

      if (email !== checkEmail) {
        userRequest.email = email;
        userRequest.username = email;
      }

      const userResponse = yield axios.put(`/users/${formValues.primary_details._id}`, userRequest);

      const {
        address1,
        address2,
        city,
        stateId: state,
        zipcode,
        gender,
        country,
        _id,
      } = formValues;

      const { date_of_birth } = payload;
      const customerRequest = {
        date_of_birth,
        address1,
        address2,
        city,
        state,
        zipcode,
        gender,
        country,
        primary_details: userResponse.data._id,
      };

      const customerResponse = yield axios.put(`/customers/${_id}`, customerRequest);
      const myCustomer = { ...customerResponse.data };

      if (imageFile) {
        console.log('payload.imageid', payload.imageid)
        if(payload.imageid != "") {
        console.log('payload.imageid 1', payload.imageid)
        yield admin.delete(`/upload/files/${payload.imageid}`);
        }
        const file = new FormData();
        file.append("files", imageFile);
        file.append("refId", customerResponse.data._id);
        file.append("ref", "customers");
        file.append("field", "photo");

        const fileResponse = yield axios.post("/upload?files", file, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        myCustomer.photo = fileResponse.data === true ? imageFile : fileResponse.data[0];
      }
      myCustomer.primary_details.phonenumber = formatPhone(myCustomer.primary_details.phonenumber);
      yield put(toggleCustomerModal(false));
      yield put(updateCustomerList(myCustomer));
      yield put(submitEditCustomerDetailsResponse(myCustomer));
    }
  } catch (error) {
    yield put(customerFailResponse(error.response.data.message));
    yield put(adminBookFailResponse(error.response.data.message));
  }
}

function* fetchCustomerDelete({ payload }) {
  try {
    const { allContact } = payload;
    let deleteCustomerIds = allContact.filter(customer => customer.selected);
    const deletedCustomerPrimaryIds = deleteCustomerIds.map(
      customer => customer.primary_details._id
    );

    deleteCustomerIds = deleteCustomerIds.map(employee => employee._id);

    const myUsersRequestData = deletedCustomerPrimaryIds.map(id => axios.delete(`/users/${id}`));
    const myCustomersRequestData = deleteCustomerIds.map(id => axios.delete(`/customers/${id}`));

    const usersResponse = yield Promise.all(myUsersRequestData);
    const CustomersResposne = yield Promise.all(myCustomersRequestData);

    yield put(selectedCustomerDeleteResposne(deleteCustomerIds));
  } catch (error) {
    yield put(customerFailResponse(error.response.data.message));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(CUSTOMER_ADMIN_FETCH_ALL_CONTACT, fetchCustomerRequest),
    takeEvery(SUBMIT_NEW_CUSTOMER_ADMIN, submitNewCustomer),
    takeEvery(SELECTED_CUSTOMER_DELETE, fetchCustomerDelete),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/CustomerAdminSaga.js